<template>
  <div class="mt-3">
    <div class="title">
      <font-awesome-icon icon="check" class="font-awesome-icon order-details-delivery-date"/>
      Geleverd: {{ orderDetails.deliveryDate | deliveryDate }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      orderDetails() {
        return this.$store.getters.orderDetails
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    font-size: 1.1em;
    font-weight: bold;
  }

  .order-details-delivery-date {
    color: $green;
    margin-right: 5px;
  }
</style>
